function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState, useCallback } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ThemeExport } from '@deephaven/components';
import { dhSquareFilled, vsCheck, vsChromeClose, vsEdit, vsPaintcan, vsTrash } from '@deephaven/icons';
import "./VisibilityOrderingGroup.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function VisibilityOrderingGroup(props) {
  var _group$color;
  var group = props.group,
    onDelete = props.onDelete,
    onColorChange = props.onColorChange,
    onNameChange = props.onNameChange,
    validateName = props.validateName;
  var isNew = group.isNew;
  var nameInputRef = useRef(null);
  var colorInputRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isColorInputOpen = _useState2[0],
    setIsColorInputOpen = _useState2[1];
  var _useState3 = useState(isNew ? '' : group.name),
    _useState4 = _slicedToArray(_useState3, 2),
    name = _useState4[0],
    setName = _useState4[1];
  var _useState5 = useState(isNew),
    _useState6 = _slicedToArray(_useState5, 2),
    isEditing = _useState6[0],
    setIsEditing = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    shouldValidate = _useState8[0],
    setShouldValidate = _useState8[1];
  var nameValidationError = name !== group.name ? validateName(name) : '';
  var isValid = isNew && !shouldValidate || nameValidationError === '';
  var colorInputBlurHandler = useCallback(() => {
    setIsColorInputOpen(false);
  }, []);
  useEffect(function focusEditInput() {
    if (isEditing && nameInputRef.current) {
      // This is solely b/c RTL doesn't count select as focusing the element
      // Might be fixed in v13+ of RTL
      nameInputRef.current.focus();
      nameInputRef.current.select();
    }
  }, [isEditing]);
  useEffect(function openColorInput() {
    if (isColorInputOpen) {
      var _colorInputRef$curren, _colorInputRef$curren2;
      (_colorInputRef$curren = colorInputRef.current) === null || _colorInputRef$curren === void 0 || _colorInputRef$curren.click();
      // Mostly for testing. Chrome seems to not give the hidden input focus
      // Really would only affect screen readers
      (_colorInputRef$curren2 = colorInputRef.current) === null || _colorInputRef$curren2 === void 0 || _colorInputRef$curren2.focus();

      /**
       * Adding this event handler is for Firefox on Mac
       * There seems to be buggy behavior when multiple color inputs are on the same page
       * Clicking between the inputs without closing the previous causes a bad state
       * The user gets to a point where they can't open most of the pickers
       * https://bugzilla.mozilla.org/show_bug.cgi?id=1618418
       * https://bugzilla.mozilla.org/show_bug.cgi?id=975468
       * Instead, we remove the color input when any focus is returned to the window
       * This causes Firefox on Mac to mostly operate correctly
       * Firefox seems to ignore the first click back into the window and emit no event
       * So opening a color picker when another is open requires 2 clicks in Firefox
       */
      window.addEventListener('click', colorInputBlurHandler, true);
    }
    return () => window.removeEventListener('click', colorInputBlurHandler, true);
  }, [isColorInputOpen, colorInputBlurHandler]);
  var handleConfirm = () => {
    if (isValid) {
      // Don't trigger change if the value is the same
      if (group.name !== name) {
        onNameChange(group, name);
      }
      setIsEditing(false);
    }
  };
  var handleCancel = () => {
    if (isNew) {
      onDelete(group);
      return;
    }
    setName(group.name);
    setIsEditing(false);
  };
  var handleEditKeyDown = e => {
    setShouldValidate(true);
    if (e.key === 'Enter') {
      e.stopPropagation();
      handleConfirm();
    }
    if (e.key === ' ') {
      e.stopPropagation();
    }
    if (e.key === 'Escape') {
      handleCancel();
    }
  };
  if (isEditing) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "editing-container",
        children: [/*#__PURE__*/_jsx("input", {
          ref: nameInputRef,
          className: classNames('form-control', {
            'is-invalid': !isValid
          }),
          value: name,
          placeholder: "Group Name",
          onChange: e => setName(e.target.value),
          onKeyDown: handleEditKeyDown,
          onBlur: () => setShouldValidate(true)
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          icon: vsCheck,
          tooltip: "Confirm",
          onClick: handleConfirm
        }), /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          icon: vsChromeClose,
          tooltip: "Cancel",
          onClick: handleCancel
        })]
      }), !isValid && /*#__PURE__*/_jsx("p", {
        className: "mb-0 validate-label-error text-danger",
        children: nameValidationError
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "group-name-wrapper",
    children: [/*#__PURE__*/_jsx("span", {
      className: "column-name",
      children: name
    }), /*#__PURE__*/_jsx(Button, {
      className: "p-1 mx-1",
      kind: "ghost",
      icon: vsEdit,
      tooltip: "Edit",
      onClick: () => {
        setIsEditing(true);
      }
    }), /*#__PURE__*/_jsxs("span", {
      className: "right-buttons",
      children: [/*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        icon: vsTrash,
        tooltip: "Delete group",
        onClick: () => onDelete(group)
      }), /*#__PURE__*/_jsx(Button, {
        kind: "ghost",
        className: "color-swatch mr-1",
        icon: group.color !== undefined ? /*#__PURE__*/_jsxs("span", {
          className: "fa-layers",
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            className: "color-swatch",
            icon: dhSquareFilled,
            color: ThemeExport.white,
            transform: "down-1"
          }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
            className: "color-swatch",
            icon: dhSquareFilled,
            color: group.color,
            transform: "shrink-2 down-1"
          })]
        }) : vsPaintcan,
        tooltip: "Set color"
        /**
         * Toggle to close the picker on Chrome
         * Prevents Firefox on Mac from getting into a stuck state
         * Does not close on Firefox b/c the picker stays open when the element is removed
         */,
        onClick: () => setIsColorInputOpen(val => !val)
      }), isColorInputOpen && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("input", {
          "aria-label": "Color input",
          ref: colorInputRef,
          type: "color",
          list: "presetColors",
          value: (_group$color = group.color) !== null && _group$color !== void 0 ? _group$color : ThemeExport['content-bg'],
          style: {
            visibility: 'hidden',
            width: 0,
            height: 0,
            padding: 0,
            border: 0
          },
          onChange: e => {
            onColorChange(group, e.target.value);
          }
        }), /*#__PURE__*/_jsxs("datalist", {
          id: "presetColors",
          children: [/*#__PURE__*/_jsx("option", {
            children: ThemeExport['content-bg']
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport.primary
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport.foreground
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport.green
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport.yellow
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport.orange
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport.red
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport.purple
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport.blue
          }), /*#__PURE__*/_jsx("option", {
            children: ThemeExport['gray-400']
          })]
        })]
      })]
    })]
  });
}
//# sourceMappingURL=VisibilityOrderingGroup.js.map